
    import '/mnt/src/components/Tip/index.md?watch=parent';
    export const demoIndex = {
  ids: ["tip-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tip/index.md?type=demo')
};